<template>
  <div>
    <div class="g-nav">
      <div class="n-nav">
        <!-- 节日提示tips -->
        <div class="notice" v-if="noticeType">
          <div @click.prevent="hrefUrl" class="noticeContent">
            <p>通知：祝新老客户五一节日快乐！假期平台下单功能不受影响，订单受理时间延迟至5月5日，给您带来的不便敬请谅解！紧急联系人--刘工：13421832556、0752-5283248</p>
            <img src="./close.svg" class="closeNotice" @click.stop="closeNotice" />
          </div>
        </div>
        <div style="position: relative" class="n-main-box">
          <div class="n-main">
            <div class="n-left">
              <a class="n-logo" :href="url.domain"> <img :src="require('./logo.svg')" alt="InZ应龙" /></a>
              <div class="ul">
                <ul>
                  <li id="trackEvent_indexBtn" class="icon-down" @click="indexPage">首页</li>
                  <li @mouseenter="enter(1)" @mouseleave="leave" class="icon-down">
                    在线下单<span class="fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 1" class="panel-main panel-item">
                      <div class="p-main">
                        <div class="p-order">
                          <h3>PCB+PCBA+BOM</h3>
                          <p>一站式在线估价&下单，可视化交付体验，专业柔性制造系统及供应链，满足客户个性化多样化的研发、生产需求。</p>
                          <a :href="url.orderDomain + '/index/inquire'" id="trackEvent_IDMGo" class="p-btn">立即下单</a>
                        </div>
                        <a rel="nofollow" target="_blank" :href="url.orderDomain + '/index/PCB'" class="p-pcb idm-item">
                          <h3>PCB</h3>
                          <p>高端特色PCB样板、快板；兼容少量多品种、中批量生产</p>
                          <div class="list">
                            <ul>
                              <li>HDI板</li>
                              <li>高频板</li>
                              <li>高多层板</li>
                              <li>金属基板</li>
                              <li>刚挠结合板</li>
                              <li>厚铜电源板</li>
                            </ul>
                          </div>
                        </a>
                        <a target="_blank" rel="nofollow" :href="url.orderDomain + '/index/PCBA'" class="p-pcba idm-item">
                          <h3>PCBA</h3>
                          <p>高精密、智能硬件模块装联 大批量装联服务</p>
                          <div class="list">
                            <ul>
                              <li>SMT表面贴膜</li>
                              <li>微组装</li>
                              <li>THT通插装</li>
                              <li>工业防护&可靠性测试</li>
                            </ul>
                          </div>
                        </a>
                        <a target="_blank" rel="nofollow" :href="url.orderDomain + '/index/BOM'" class="p-bom idm-item">
                          <h3>BOM</h3>
                          <p>资深工程师全程服务、高品质BOM咨询服务</p>
                          <div class="list">
                            <ul>
                              <li>大数据+资深工程师配齐</li>
                              <li>BOM自动匹配+成本评估</li>
                              <li>研发、计划、成本核算服务</li>
                            </ul>
                          </div>
                        </a>
                        <!-- <a target="_blank" rel="nofollow" :href="url.domain + '/orderIC/onlineInquiry'" class="p-ic idm-item">
                          <h3>元器件</h3>
                          <p>元器件专业分销平台，一站式满足元器件采购</p>
                          <div class="list">
                            <ul>
                              <li>海量元器件数据+自动数据匹配</li>
                              <li>快速采购报价+高效交付</li>
                              <li>询报价专属服务</li>
                            </ul>
                          </div>
                        </a> -->
                      </div>
                    </div>
                  </li>
                  <!-- <li
                    id="trackEvent_indexBtn"
                    class="icon-down"
                    @click="indexPageIC"
                  >
                    元器件采购
                  </li> -->
                  <li @mouseenter="enter(4)" @mouseleave="leave" class="icon-down">
                    制造能力<span class="fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 4" class="pro-panel panel-item">
                      <div class="pro-main">
                        <div class="pro-left">
                          <div :class="['tab', tabFlag == 1 ? 'active' : '']" @mouseover="tab(1)">PCB生产制造</div>
                          <div :class="['tab', tabFlag == 2 ? 'active' : '']" @mouseover="tab(2)">PCBA装联</div>
                          <div :class="['tab', tabFlag == 3 ? 'active' : '']" @mouseover="tab(3)">BOM配齐</div>
                        </div>
                        <div class="pro-right">
                          <div v-if="tabFlag == 1" class="content tab-c">
                            <div class="r-main">
                              <a :href="url.domain + '/technology/pcbCraftSecondary?type=1'" target="_blank" class="item">
                                <img :src="require('./img/product_img_1.png')" alt="HDI板" />
                                <div class="text">
                                  <p>HDI板</p>
                                  <span>8层 FR4 S1000-2 4.0mm</span>
                                </div>
                              </a>
                              <a :href="url.domain + '/technology/pcbCraftSecondary?type=2'" target="_blank" class="item">
                                <img :src="require('./img/product_img_2.png')" alt="高多层板" />
                                <div class="text">
                                  <p>高多层板</p>
                                  <span>8层 FR4 S1000-2 4.0mm</span>
                                </div>
                              </a>
                              <a :href="url.domain + '/technology/pcbCraftSecondary?type=4'" target="_blank" class="item">
                                <img :src="require('./img/product_img_3.png')" alt="高频板" />
                                <div class="text">
                                  <p>高频板</p>
                                  <span>8层 FR4 S1000-2 4.0mm</span>
                                </div>
                              </a>
                              <a :href="url.domain + '/technology/pcbCraftSecondary?type=6'" target="_blank" class="item">
                                <img :src="require('./img/product_img_4.png')" alt="金属基板" />
                                <div class="text">
                                  <p>金属基板</p>
                                  <span>8层 4.0mm</span>
                                </div>
                              </a>
                              <a :href="url.domain + '/technology/pcbCraftSecondary?type=5'" target="_blank" class="item">
                                <img :src="require('./img/product_img_5.png')" alt="厚铜电源板" />
                                <div class="text">
                                  <p>厚铜电源板</p>
                                  <span>8层 4.0mm</span>
                                </div>
                              </a>
                              <a :href="url.domain + '/technology/pcbCraftSecondary?type=3'" target="_blank" class="item">
                                <img :src="require('./img/product_img_6.png')" alt="刚挠结合板" />
                                <div class="text">
                                  <p>刚挠结合板</p>
                                  <span>8层 4.0mm</span>
                                </div>
                              </a>
                            </div>
                            <div class="r-more">
                              <a :href="url.domain + '/technology/pcbCraft'" class="a-more">了解更多</a>
                              <a rel="nofollow" :href="url.orderDomain + '/index/PCB'" class="btn-more">马上下单</a>
                            </div>
                          </div>
                          <div v-if="tabFlag == 2" class="content tab-c">
                            <div class="r-main">
                              <div class="item-A">
                                <img :src="require('./img/PCBA_icon_1.png')" />
                                <h3>SMT表面贴膜</h3>
                                <p>
                                  Surface Mounted<br />
                                  Technology
                                </p>
                              </div>
                              <div class="item-A">
                                <img :src="require('./img/PCBA_icon_2.png')" />
                                <h3>THT通插装</h3>
                                <p>
                                  Through Hole <br />
                                  Technology
                                </p>
                              </div>
                              <div class="item-A">
                                <img :src="require('./img/PCBA_icon_3.png')" />
                                <h3>微组装</h3>
                                <p>
                                  Microassembly <br />
                                  process
                                </p>
                              </div>
                              <div class="item-A">
                                <img :src="require('./img/PCBA_icon_4.png')" />
                                <h3>工业防护&可靠性测试</h3>
                                <p>
                                  Industrial protection & <br />
                                  reliability testing
                                </p>
                              </div>
                            </div>
                            <div class="r-more">
                              <a rel="nofollow" :href="url.domain + '/technology/pcbACraft'" class="a-more">了解更多</a>
                              <a rel="nofollow" :href="url.orderDomain + '/index/PCBA'" class="btn-more">马上下单</a>
                            </div>
                          </div>
                          <div v-if="tabFlag == 3" class="content tab-c">
                            <div class="r-main">
                              <div class="item-B item-A">
                                <img :src="require('./img/BOM_icon_1.png')" />
                                <h3>大数据+资深工程师配齐</h3>
                                <div class="list-B">
                                  <ul>
                                    <li>高效自动匹配 自研物料库</li>
                                    <li>优质原厂数据</li>
                                  </ul>
                                </div>
                              </div>
                              <div class="item-B item-A">
                                <img :src="require('./img/BOM_icon_2.png')" />
                                <h3>BOM自动匹配+成本预估</h3>
                                <div class="list-B">
                                  <ul>
                                    <li>现货采购</li>
                                    <li>工程师配齐</li>
                                  </ul>
                                </div>
                              </div>
                              <div class="item-B item-A">
                                <img :src="require('./img/BOM_icon_3.png')" />
                                <h3>研发、计划、成本核算服务</h3>
                                <div class="list-B">
                                  <ul>
                                    <li>系统自动匹配</li>
                                    <li>精准数据对接 成本管理</li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div class="r-more">
                              <a :href="url.domain + '/technology/pcbCraft'" class="a-more">了解更多</a>
                              <a :href="url.orderDomain + '/index/inquire'" rel="nofollow" class="btn-more">马上下单</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- @click="indexPageDesign" -->
                  <li id="trackEvent_indexBtn" class="icon-down">
                    <a href="/cad">设计能力</a>
                  </li>
                  <li @mouseenter="enter(6)" @mouseleave="leave" class="icon-down">
                    解决方案<span class="fa fa-angle-down reg-d"></span>
                    <div class="pro-panel panel-item" v-if="tabIndex == 6">
                      <div class="pro-main solve-main">
                        <div class="solve-left">
                          <h3 class="h3-text">行业解决方案</h3>
                          <p class="detail-text">InZ应龙面向不同行业和领域 的业务场景，提供从创意到产 品，生产到制造全链条硬件研 发解决方案，助力客户增效降 本，快速实现市场价值。</p>
                        </div>
                        <div class="solve-right">
                          <div class="content">
                            <div v-for="(item, index) in solveList" class="item-parent" :key="index">
                              <a :href="`https://inzaowu.com${item.url}`" target="_blank">
                                <div class="solve-item" @mouseenter="enterImg(index)" @mouseleave="leaveImg">
                                  <img :src="enterImgFlag == index ? item.img2 : item.img1" />
                                  <div class="item-title">{{ item.h2 }}</div>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li id="trackEvent_indexBtn" class="icon-down" @click="indexPageS">生态合作</li>
                  <li id="trackEvent_indexBtn" class="icon-down" @click="indexPageUs">关于我们</li>
                </ul>
              </div>
            </div>
            <div class="n-right">
              <div class="loginB" v-if="!userInfo">
                <!-- :href="url.domain + '/login/register'" -->
                <a class="reg-btn" @click="LoginC">注册</a>
                <a @click="LoginC" class="login-btn" rel="nofollow"> 登录</a>
              </div>
              <div class="info-n" v-if="userInfo" :id="[userInfo ? 'headerUserInfo' : 'headerUserInfoNone']">
                <div class="info" @mouseover="enterInfo('1')" @mouseleave="leaveInfo">
                  <a class="name" :title="userInfo.realname" href="javascript:void(0);">
                    应用中心
                    <span class="fa fa-angle-down reg-d" style="text-indent: 0; margin-left: 8px"></span>
                  </a>
                  <!--  -->
                  <div v-if="InfoShow" class="info-item" v-loading="loginOutLoading">
                    <a rel="nofollow" :href="`${item.platformDomain}`" v-for="item in userRoleList" :key="item.platformType" class="item" target="_blank">
                      <img :src="item.url" />
                      {{ item.platformName }}
                    </a>
                    <!-- 没有授权的时候展示 -->
                    <a rel="nofollow" v-if="userRoleList.length == 0" class="item" target="_blank">暂无应用</a>
                  </div>
                </div>
                <div @mouseover="enterInfo('2')" @mouseleave="leaveInfo" class="userName-r">
                  <a class="name" :title="userInfo.realname" href="javascript:void(0);">{{ userInfo.realname }}</a>
                  <div v-if="InfoCenterShow" class="panenl-u-r">
                    <div class="userInfo-item-t-r">
                      <div class="img-info">
                        <div class="img">
                          <img src="http://cmsfile.kingbrother.com//f359626d0f84efdfc0f07e27bbfd5a02.jpg" />
                        </div>
                        <div class="user-code-r">
                          <p>客户代码：{{ userInfo.workNo }}</p>
                          <p>登录账号：{{ userInfo.realname }}</p>
                        </div>
                      </div>
                      <!-- <div class="user-system-r" @click="goSystem">
                        个人中心
                      </div> -->
                    </div>
                    <!-- <div class="account-item-t-r">
                      <div class="panenl-title">
                        <img src="./img/nav-user/user_icon_account.png" />
                        账户总览
                      </div>
                      <div class="balance">
                        <div class="balance-num">
                          余额:<span>￥{{ amount }}</span>
                        </div>
                        <div class="top-up" @click="toAdd">充值</div>
                      </div>
                    </div>
                    <div class="todoList-t-r">
                      <div class="panenl-title">
                        <img src="./img/nav-user/user_icon_Upcoming.png" />
                        待办事项
                      </div>
                      <div class="orderList-t-r">
                        <div class="orderList-tab-r">
                          <div class="tab-eq">
                            <h3>
                              {{ orderCountStatusDtos.pendingReplyEQCount }}
                            </h3>
                            <p>生产研发待回复EQ</p>
                          </div>
                          <div class="tab-eq">
                            <h3>
                              {{
                                orderCountStatusDtosDesign.pendingReplyEQCount
                              }}
                            </h3>
                            <p>设计待回复EQ</p>
                          </div>
                        </div>
                        <div class="orderList-main-r">
                          <div class="order-list">
                            <div class="title">生产研发订单:</div>
                            <div class="list">
                              <div
                                class="item"
                                v-for="(
                                  l, index
                                ) in orderCountStatusDtos.orderCountStatusDtos"
                                :key="index"
                              >
                                <h3>{{ l.count | maxNum }}</h3>
                                <p>{{ l.orderStatus | status }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="order-list">
                            <div class="title">设计订单:</div>
                            <div class="list">
                              <div
                                class="item"
                                v-for="(
                                  l, index
                                ) in orderCountStatusDtosDesign.orderCountStatusDtos"
                                :key="index"
                              >
                                <h3>{{ l.count | maxNum }}</h3>
                                <p>{{ l.orderStatus | statusDesign }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <div class="outLogin">
                      <a href="javascript:void(0);" class="item" id="loginOut" @click="loginOutHandle">退出登录</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="bjNavFlag" class="bj-nav"></div>
    </div>
  </div>
</template>

<script>
import * as util from 'assets/js/util'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { loginOut } from 'api/login'
import { logout, queryUserRoleCode, currentList, userInfo, orderList, orderListDes } from 'api/orderNew'
import { ERR_OK } from 'api/config'
import cookies from 'vue-cookie'

export default {
  props: {
    isFixed: false,
    bgColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabFlag: 1,
      bjNavFlag: false,
      loginOutLoading: false,
      InfoShow: false,
      InfoCenterShow: false,
      noticeType: false,
      noticeWindow: false,
      tabIndex: -1,
      config: util.config,
      typeindex: 1,
      isactive: {},
      enterImgFlag: -1,
      solveList: [
        {
          url: '/solution/smartHardware',
          h2: '智能硬件',
          img1: require('./img/nav-solution/solution-n/solution_img_1.png'),
          img2: require('./img/nav-solution/solution-h/solution_img_1.png')
        },
        {
          url: '/solution/medicalTreatment',
          h2: '医疗',
          img1: require('./img/nav-solution/solution-n/solution_img_2.png'),
          img2: require('./img/nav-solution/solution-h/solution_img_2.png')
        },
        {
          url: '/solution/InternetOfThings',
          h2: '物联网',
          img1: require('./img/nav-solution/solution-n/solution_img_3.png'),
          img2: require('./img/nav-solution/solution-h/solution_img_3.png')
        },
        {
          url: '/solution/communication',
          h2: '通讯',
          img1: require('./img/nav-solution/solution-n/solution_img_4.png'),
          img2: require('./img/nav-solution/solution-h/solution_img_4.png')
        },
        {
          url: '/solution/electricPower',
          h2: '电力',
          img1: require('./img/nav-solution/solution-n/solution_img_5.png'),
          img2: require('./img/nav-solution/solution-h/solution_img_5.png')
        },

        {
          url: '/solution/newEnergy',
          h2: '新能源',
          img1: require('./img/nav-solution/solution-n/solution_img_6.png'),
          img2: require('./img/nav-solution/solution-h/solution_img_6.png')
        }
      ],
      SystemIcon1: require('./img/nav-user/application_icon_1.png'), // 个人中心
      SystemIcon2: require('./img/nav-user/application_icon_2.png'), // 业务后台
      SystemIcon3: require('./img/nav-user/application_icon_3.png'), // 销售中心
      SystemIcon4: require('./img/nav-user/application_icon_4.png'), // 供应商管理
      SystemIcon5: require('./img/nav-user/application_icon_5.png'), // 合作伙伴中心
      SystemIcon6: require('./img/nav-user/application_icon_6.png'), // 工程能力中心
      SystemIcon7: require('./img/nav-user/application_icon_7.png'), // 成本报价中心
      SystemIcon8: require('./img/nav-user/application_icon_8.png'), // ERP系统
      productOrderList: [
        { num: 1, status: 0 },
        { num: 100, status: 1 },
        { num: 22, status: 2 },
        { num: 56, status: 3 }
      ],
      desginOrderList: [
        { num: 66, status: 0 },
        { num: 100, status: 1 },
        { num: 33, status: 2 },
        { num: 0, status: 3 }
      ],
      queryUserRoleList: '',
      img: require('./icon_face@2x.png'),
      amount: '-', //余额
      orderCountStatusDtos: {}, //生产研发订单统计
      orderCountStatusDtosDesign: {} //设计订单统计
    }
  },
  created() {
    this.rediUrl = encodeURIComponent(window.location.href)
    this.nowTime()
    if (this.authorToken) {
      queryUserRoleCode('', this.authorToken).then((res) => {
        console.log(res, 'rrrrrrrrrr')
        if (res.data.code == 200) {
          this.queryUserRoleList = res.data.result
        } else if (res.data.code == 401) {
          this.signOut()
          window.location.href = this.url.domain + '/login/index'
        }
      })
    }
  },
  computed: {
    url() {
      return util.config
    },
    onRoutes() {
      if (this.$route.matched.length < 1) {
        return this.$route.path
        // return window.location.href;
      }
      let url = window.location.href
      if (url.indexOf('?') != -1) {
        url = url.split('?')[0]
        return url
      } else {
        return url
      }
    },
    ...mapGetters(['authorToken', 'userInfo'])
  },
  filters: {
    status(val) {
      const mapList = {
        0: '待审核',
        2: '待支付',
        3: '待发货',
        456: '待收货'
      }
      return mapList[val]
    },
    statusDesign(val) {
      const mapList = {
        1: '待审核',
        2: '待支付',
        3: '设计中',
        4: '待验收'
      }
      return mapList[val]
    },
    maxNum(val) {
      if (Number(val) > 99) {
        return '99+'
      } else {
        return val
      }
    }
  },
  mounted() {
    var value = cookies.get('noticeStatus')
    if (value) {
      this.noticeWindow = false
      this.noticeType = false
    }
    this.currentListFun()
    this.getUserInfo()
    this.getOrderList()
  },
  methods: {
    //toAdd
    toAdd() {
      window.location.href = 'https://tc.devplatform.eec2m.com/property/wallet'
    },
    // 获取用户权限
    currentListFun() {
      if (this.authorToken) {
        currentList('', this.authorToken).then((res) => {
          console.log(res, 'rrrrrrrrrrrrrrrrrr')
          if (res.data.code == 200) {
            this.userRoleList = res.data.result.map((item) => {
              item.url = this.handleImage(item.platformType)
              return item
            })
          }
        })
      }
    },
    //获取用户余额
    getUserInfo() {
      if (this.authorToken) {
        userInfo('', this.authorToken).then((res) => {
          console.log(res, this.amount, 'resQQQQQQQQQQQQQQQQ')
          this.amount = res.data.result.amount
        })
      }
    },
    //获取用户订单信息
    getOrderList() {
      if (this.authorToken) {
        // const _this = this;
        //生产
        orderList('', this.authorToken).then((res) => {
          let ListArr = []
          res.data.result.orderCountStatusDtos.forEach((item) => {
            // console.log("item",item)
            if (item.orderStatus == 0) {
              ListArr.push({ count: item.count, orderStatus: 0 })
            } else if (item.orderStatus == 2) {
              ListArr.push({ count: item.count, orderStatus: 2 })
            } else if (item.orderStatus == 3) {
              ListArr.push({ count: item.count, orderStatus: 3 })
            } else if (item.orderStatus == 456) {
              ListArr.push({ count: item.count, orderStatus: 456 })
            }
          })
          this.orderCountStatusDtos = JSON.parse(JSON.stringify(res.data.result))
          this.$set(this.orderCountStatusDtos, 'orderCountStatusDtos', ListArr)
          console.log('cccccccccc', res, this.orderCountStatusDtos)
        })
        // 设计
        orderListDes('', this.authorToken).then((res) => {
          console.log('aaaaaaaaaaa', res, this.orderCountStatusDtosDesign)
          let ListArr = []
          res.data.result.orderCountStatusDtos.forEach((item) => {
            // console.log("item",item)
            if (item.orderStatus == 1) {
              ListArr.push({ count: item.count, orderStatus: 1 })
            } else if (item.orderStatus == 2) {
              ListArr.push({ count: item.count, orderStatus: 2 })
            } else if (item.orderStatus == 3) {
              ListArr.push({ count: item.count, orderStatus: 3 })
            } else if (item.orderStatus == 4) {
              ListArr.push({ count: item.count, orderStatus: 4 })
            }
          })
          this.orderCountStatusDtosDesign = JSON.parse(JSON.stringify(res.data.result))
          this.$set(this.orderCountStatusDtosDesign, 'orderCountStatusDtos', ListArr)
          console.log('bbbbbbbbbbbbbbbbb', res, this.orderCountStatusDtosDesign)
        })
      }
    },
    handleImage(type) {
      let url = ''
      // require("@/assets/image/example.jpg");
      switch (type) {
        case 1:
          url = require('./img/nav-user/application_icon_1.png')
          break
        case 2:
          url = require('./img/nav-user/application_icon_2.png')
          break
        case 8:
          url = require('./img/nav-user/application_icon_3.png')
          break
        case 3:
          url = require('./img/nav-user/application_icon_4.png')
          break
        case 7:
          url = require('./img/nav-user/application_icon_5.png')
          break
        case 6:
          url = require('./img/nav-user/application_icon_6.png')
          break
        case 5:
          url = require('./img/nav-user/application_icon_7.png')
          break
        case 10:
          url = require('./img/nav-user/application_icon_8.png')
          break
        case 11:
          url = require('./img/nav-user/application_icon_9.png')
          break
        case 12:
          url = require('./img/nav-user/application_icon_10.png')
          break
        case 13:
          url = require('./img/nav-user/application_icon_11.png')
          break
        case 14:
          url = require('./img/nav-user/application_icon_12.png')
          break
        case 15:
          url = require('./img/nav-user/application_icon_9.png')
          break
        default:
          url = require('./img/nav-user/application_icon_9.png')
          break
      }
      return url
    },
    // 登陆跳转
    LoginC() {
      // this.tipTestMsg()
      // return

      let url = this.url.domain + '/login/index'
      const params = {
        type: 'eeidmOrder',
        redirect: this.url.orderDomain + '/index/inquire'
      }
      cookies.set('redirectLogin', JSON.stringify(params), {
        domain: this.url.cookieDomain
      })
      window.location.href = url
    },
    // 跳转
    hrefUrl() {
      window.location.href = `${util.config.domain}/newsDetail?detailId=9480`
    },
    goSystem() {
      window.open(this.url.serverDomain)
      // window.location.href = this.url.serverDomain
    },
    // 跳转首页
    indexPage() {
      // console.log("跳转hahhah");
      window.location.href = util.config.domain
    },
    // 跳转元器件下单
    indexPageIC() {
      // console.log("跳转hahhah");
      window.location.href = util.config.domain + '/orderIC/onlineInquiry'
    },
    indexPageDesign() {
      window.location.href = util.config.orderDomain + '/cadOrder'
    },
    indexPageS() {
      const w = window.open('about:blank')
      w.location.href = util.config.domain + '/supplier'
    },
    indexPageUs() {
      window.location.href = util.config.domain + '/aboutUs'
    },
    enterImg(index) {
      this.enterImgFlag = index
    },
    leaveImg() {
      this.enterImgFlag = '-1'
    },
    // 个人信息
    enterInfo(index) {
      // console.log('chuf?11111111111111')
      index == 1 ? (this.InfoShow = true) : (this.InfoCenterShow = true)
    },
    leaveInfo() {
      // console.log('chuf?12121212')
      this.InfoShow = false
      this.InfoCenterShow = false
    },
    // 生产与制造
    tab(index) {
      this.tabFlag = index
    },
    enter(index) {
      console.log('触发')
      this.tabIndex = index
      this.bjNavFlag = true
    },
    leave() {
      this.tabIndex = -1
      this.bjNavFlag = false
    },
    // 时间
    nowTime() {
      var now = new Date()
      var nowYear = now.getFullYear()
      var nowMonth = now.getMonth() + 1
      var nowDay = now.getDate()
      // console.log("年",nowYear,"月",nowMonth,"日",nowDay)
      if (nowYear == 2022) {
        if ((nowMonth == 4 && nowDay <= 30) || (nowMonth == 5 && nowDay <= 4)) {
          this.noticeType = true
          this.$emit('noticeType', true)
        } else {
          this.noticeType = false
          this.$emit('noticeType', false)
        }
      } else {
        this.$emit('noticeType', false)
      }
      //   if (nowYear >= 2021 && nowMonth >= 10 && nowDay >= 7) {
      //     this.noticeType = false;
      //   }
    },
    closeWindow() {
      this.noticeWindow = false
      cookies.set('noticeStatus', 'is', { domain: this.url.cookieDomain })
    },
    closeNotice() {
      this.noticeType = false
      this.$emit('noticeType', false)
      cookies.set('noticeStatus', 'is', { domain: this.url.cookieDomain })
    },
    lookWindow() {
      this.noticeWindow = true
      // cookies.delete('noticeStatus', { domain: util.config.cookieDomain })
    },
    changetype(val) {
      sessionStorage.setItem('typeIndex', val)
      this.nextTick(() => {})
    },
    // 退出登录
    loginOutHandle() {
      this.loginOutLoading = true
      logout('', this.authorToken).then((res) => {
        console.log(res, 'rrrrrrrrrrrrrrrrrr退出')
        if (res.data.code == 200) {
          this.$message.success(res.data.message)
          this.signOut()
        } else {
          this.$message.error(res.data.message)
        }
        this.loginOutLoading = false
      })
      return false
      // this._loginOut()
      //   .then(res => {
      //     if (res.code) {
      //       if (res.code != ERR_OK) {
      //         return Promise.reject(res);
      //       }
      //       this.signOut();
      //     }
      //   })
      //   .catch(erro => {
      //     console.log(erro);
      //     if (!erro.isCancel) {
      //       this.$message.error(erro.message);
      //     }
      //   })
      //   .finally(() => {
      //     this.loginOutLoading = false;
      //   });
    },
    _loginOut() {
      var param = {
        UID: this.userInfo.UserId,
        UserCode: this.userInfo.UserCode,
        UserName: this.userInfo.CustName
      }
      return loginOut(param)
    },
    ...mapMutations({
      UpdateAuthorization: 'UPDATE_AUTHORTOKEN'
    }),
    ...mapActions(['updateUserInfo', 'signOut'])
  },
  components: {}
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '~assets/scss/compile';
@import './nav.scss';
a {
  color: #2b333a;
}
</style>



// WEBPACK FOOTER //
// src/components/common/nav/nav.vue